export default __webpack_public_path__ + "static/media/voice.39c23936.svg";